// Shared team data — titleKey maps to translations.js for Hindi support

export const categories = [
  {
    key: "ot", titleKey: "deptOT", color: "#0077b6",
    bg: "rgba(0,119,182,0.08)", border: "rgba(0,119,182,0.2)",
    members: [
      { name: "Ramniwas", designation: "OT Technician", image: "/Ramniwas.png" },
    ],
  },
  {
    key: "clinical", titleKey: "deptClinical", color: "#0096c7",
    bg: "rgba(0,150,199,0.08)", border: "rgba(0,150,199,0.2)",
    members: [
      { name: "Dr Sachin", designation: "Clinical Head", image: "/DrSachin.png" },
      { name: "Dr Shivani", designation: "Clinical Specialist", image: "/DrShivani.png" },
      { name: "Dr Vikas", designation: "Clinical Specialist", image: "/DrVikas.png" },
    ],
  },
  {
    key: "pharmacy", titleKey: "deptPharmacy", color: "#7c3aed",
    bg: "rgba(124,58,237,0.08)", border: "rgba(124,58,237,0.2)",
    members: [
      { name: "Punit Kumar",    designation: "Pharmacist" },
      { name: "Chirag Luniwal", designation: "Pharmacist" },
      { name: "Kuldeep",        designation: "Pharmacist" },
      { name: "Nitesh Kumar",   designation: "Pharmacist" },
    ],
  },
  {
    key: "nursing", titleKey: "deptNursing", color: "#db2777",
    bg: "rgba(219,39,119,0.08)", border: "rgba(219,39,119,0.2)",
    members: [
      { name: "Divyanshu",  designation: "Nursing Staff" },
      { name: "Priya",      designation: "Nursing Staff" },
      { name: "Ravina",     designation: "Nursing Staff" },
      { name: "Amit Kumar", designation: "Nursing Staff" },
      { name: "Varsha",     designation: "Nursing Staff" },
      { name: "Akash",      designation: "Nursing Staff" },
      { name: "Divya",      designation: "Nursing Staff" },
      { name: "Shubhanshu", designation: "Nursing Staff" },
      { name: "Parveen",    designation: "Nursing Staff" },
      { name: "Jai Singh",  designation: "Nursing Staff" },
      { name: "Jyoti",      designation: "Nursing Staff" },
      { name: "Rekha",      designation: "Nursing Staff" },
      { name: "Sapna",      designation: "Nursing Staff" },
    ],
  },
  {
    key: "admin", titleKey: "deptAdmin", color: "#b45309",
    bg: "rgba(180,83,9,0.08)", border: "rgba(180,83,9,0.2)",
    members: [
      { name: "Yashpal", designation: "Receptionist" },
    ],
  },
];

export const getInitials = name =>
  name.split(" ").map(w => w[0]).slice(0, 2).join("").toUpperCase();
